
import { ConfigProvider, Tooltip } from 'antd';

const CustomTooltip = ({ placement="top", title, children, className, ...rest }) => {
  return (
    <ConfigProvider
        theme={{
            token: {
                // colorBgSpotlight: ''
            },
        }}
>
        <Tooltip title={title} placement={placement} className={`custom-tooltip ${className}`} {...rest}>
            {children}
        </Tooltip>
    </ConfigProvider>
  );
};

export default CustomTooltip;
